(function() {
  function getHeaderOffset() {
    const header = document.querySelector('.section-header, .shopify-section-header, header, .header-wrapper, .header');
    const headerIsVisible = header && !header.classList.contains('shopify-section-header-hidden');
    const headerHeight = headerIsVisible ? Math.ceil(header.getBoundingClientRect().height) : 0;
    const secondaryHeader = document.querySelector('.bsg-flexible-columns-2-header-nav.is-visible');
    const secondaryHeaderBar = secondaryHeader && secondaryHeader.querySelector('.bsg-flexible-columns-2-header-nav__inner');
    const mobileBottomNavigation = secondaryHeader && secondaryHeader.classList.contains('bsg-flexible-columns-2-header-nav--mobile-bottom') && window.matchMedia('(max-width: 749px)').matches;
    const secondaryHeaderHeight = secondaryHeaderBar && !mobileBottomNavigation ? Math.ceil(secondaryHeaderBar.getBoundingClientRect().height) : 0;
    return headerHeight + secondaryHeaderHeight + 12;
  }

  function findAnchorTarget(anchorId) {
    const normalized = (anchorId || '').trim().replace(/^#/, '');
    if (!normalized) return null;

    const direct = document.getElementById(normalized);
    if (direct) return direct;

    const prefixedId = normalized.indexOf('shopify-section-') === 0 ? normalized : 'shopify-section-' + normalized;
    const prefixed = document.getElementById(prefixedId);
    if (prefixed) return prefixed;

    const sectionEls = document.querySelectorAll('[id^="shopify-section-"]');
    for (let i = 0; i < sectionEls.length; i += 1) {
      const currentId = sectionEls[i].id || '';
      if (currentId.endsWith('__' + normalized)) {
        return sectionEls[i];
      }
    }

    return null;
  }

  function scrollToAnchor(anchorId) {
    const target = findAnchorTarget(anchorId);
    if (!target) return false;

    const offsetTop = target.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset();
    window.scrollTo({ top: offsetTop, behavior: 'smooth' });
    return true;
  }

  function openContactFormDrawer(button) {
    const fallbackUrl = button.getAttribute('data-contact-fallback-url') || '/pages/contact-us';
    if (!window.BSNCartDrawer || typeof window.BSNCartDrawer.open !== 'function') {
      window.location.assign(fallbackUrl);
      return;
    }

    window.BSNCartDrawerContext = {
      mode: 'floating_callout',
      source: 'bsg_flexible_columns_2_navigation',
      formConfig: {
        portalId: button.getAttribute('data-hubspot-portal-id') || '',
        formId: button.getAttribute('data-hubspot-form-id') || '',
        region: button.getAttribute('data-hubspot-region') || 'na1'
      }
    };

    window.BSNCartDrawer.open();
    if (typeof window.BSNCartDrawer.refresh === 'function') {
      window.BSNCartDrawer.refresh();
    }
  }

  function getRaisedImageCoverRatio(raisedBlock) {
    if (raisedBlock.classList.contains('bsg-flexible-columns-2__raised--image-50')) return 0.3;
    if (raisedBlock.classList.contains('bsg-flexible-columns-2__raised--image-75')) return 0.1;
    return 0.2;
  }

  function updateRaisedTextOverlap(raisedBlock) {
    const media = raisedBlock.querySelector('.bsg-flexible-columns-2__raised-media');
    if (!media) return;

    const visualMedia = media.querySelector('img, video') || media;
    const mediaHeight = visualMedia.getBoundingClientRect().height;
    const overlap = Math.max(0, Math.round(mediaHeight * getRaisedImageCoverRatio(raisedBlock)));
    raisedBlock.style.setProperty('--bsg-flexible-columns-2-stack-overlap', overlap + 'px');
  }

  function initRaisedTextOverlap(sectionRoot) {
    sectionRoot.querySelectorAll('.bsg-flexible-columns-2__raised').forEach(function(raisedBlock) {
      updateRaisedTextOverlap(raisedBlock);

      if (raisedBlock.dataset.bsgFlexibleColumns2OverlapInitialized === 'true') return;
      raisedBlock.dataset.bsgFlexibleColumns2OverlapInitialized = 'true';

      const media = raisedBlock.querySelector('.bsg-flexible-columns-2__raised-media');
      if (!media) return;

      media.querySelectorAll('img, video').forEach(function(mediaEl) {
        mediaEl.addEventListener('load', function() {
          updateRaisedTextOverlap(raisedBlock);
        });
        mediaEl.addEventListener('loadedmetadata', function() {
          updateRaisedTextOverlap(raisedBlock);
        });
      });

      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(function() {
          updateRaisedTextOverlap(raisedBlock);
        });
        observer.observe(media);
        raisedBlock._bsgFlexibleColumns2ResizeObserver = observer;
      }
    });
  }

  function initSectionSlider(sectionRoot) {
    const section = sectionRoot.querySelector('[data-bsg-flexible-columns-2]');
    const slider = section && section.querySelector('[data-bsg-flexible-columns-2-slider]');
    const controls = section && section.querySelector('[data-bsg-flexible-columns-2-slider-controls]');
    if (!section || !slider || !controls || slider.dataset.bsgFlexibleColumns2SliderInitialized === 'true') return;

    const slides = Array.from(slider.children).filter(function(child) {
      return child.classList.contains('column-item');
    });
    const dots = Array.from(controls.querySelectorAll('[data-bsg-flexible-columns-2-slider-dot]'));
    const arrowContainer = controls.querySelector('.bsg-flexible-columns-2__slider-arrows');
    const previousButton = controls.querySelector('[data-bsg-flexible-columns-2-slider-previous]');
    const nextButton = controls.querySelector('[data-bsg-flexible-columns-2-slider-next]');
    const mobileQuery = window.matchMedia('(max-width: 768px)');
    const usesExtendedDesktop = section.classList.contains('bsg-flexible-columns-2--desktop-extended');
    const usesMobileDynamicHeight = section.dataset.mobileDynamicHeight === 'true';
    let updateFrame = null;
    let settleTimer = null;
    let pageCount = 1;

    if (slides.length < 2) return;
    slider.dataset.bsgFlexibleColumns2SliderInitialized = 'true';

    function sliderIsEnabled() {
      if (mobileQuery.matches) return section.dataset.mobileScroll === 'true';
      return section.dataset.desktopScroll === 'true';
    }

    function getVisibleSlides() {
      return slides.filter(function(slide) {
        return window.getComputedStyle(slide).display !== 'none';
      });
    }

    function getStep() {
      const visibleSlides = getVisibleSlides();
      if (visibleSlides.length < 2) return slider.clientWidth;
      return Math.max(1, visibleSlides[1].offsetLeft - visibleSlides[0].offsetLeft);
    }

    function getMaxScroll() {
      return Math.max(0, slider.scrollWidth - slider.clientWidth);
    }

    function getActiveIndex() {
      return Math.min(pageCount - 1, Math.max(0, Math.round(slider.scrollLeft / getStep())));
    }

    function restoreArrowContainer() {
      if (arrowContainer && arrowContainer.parentElement !== controls) controls.appendChild(arrowContainer);
    }

    function updateMobileHeight(activeIndex, visibleSlides) {
      const enabled = mobileQuery.matches && sliderIsEnabled() && usesMobileDynamicHeight;
      if (!enabled) {
        slider.style.height = '';
        return;
      }

      const activeSlide = visibleSlides[activeIndex] || visibleSlides[0];
      if (!activeSlide) return;

      const sliderStyles = window.getComputedStyle(slider);
      const verticalPadding = parseFloat(sliderStyles.paddingTop || 0) + parseFloat(sliderStyles.paddingBottom || 0);
      const targetHeight = Math.ceil(activeSlide.getBoundingClientRect().height + verticalPadding);
      slider.style.height = targetHeight + 'px';
    }

    function placeArrowContainer(activeIndex, visibleSlides) {
      const shouldPlaceInCard = sliderIsEnabled() &&
        section.classList.contains('bsg-flexible-columns-2--scroll-in-container');

      if (!shouldPlaceInCard) {
        restoreArrowContainer();
        return;
      }

      const activeSlide = visibleSlides[activeIndex] || visibleSlides[0];
      if (!activeSlide || !arrowContainer) return;

      const contentHost = activeSlide.querySelector(
        '.bsg-flexible-columns-2__raised-image-content, ' +
        '.bsg-flexible-columns-2__raised-box, ' +
        '.bsg-flexible-columns-2__text-column, ' +
        '.content-section'
      ) || activeSlide;

      if (arrowContainer.parentElement !== contentHost) contentHost.appendChild(arrowContainer);
    }

    function updateControls() {
      const enabled = sliderIsEnabled();
      const visibleSlides = getVisibleSlides();
      const maxScroll = getMaxScroll();
      pageCount = enabled ? Math.max(1, Math.min(visibleSlides.length, Math.max(1, Math.ceil(maxScroll / getStep()) + 1))) : 1;
      const activeIndex = getActiveIndex();
      const sliderRect = slider.getBoundingClientRect();

      placeArrowContainer(activeIndex, visibleSlides);
      updateMobileHeight(activeIndex, visibleSlides);

      slides.forEach(function(slide) {
        const slideRect = slide.getBoundingClientRect();
        const isOutsideDesktop = enabled && !mobileQuery.matches && (
          slideRect.left >= sliderRect.right - 1 || slideRect.right <= sliderRect.left + 1
        );
        slide.classList.toggle('is-outside-slider', isOutsideDesktop);
      });

      controls.hidden = !enabled || maxScroll <= 2;
      if (arrowContainer) arrowContainer.hidden = !enabled || maxScroll <= 2;
      dots.forEach(function(dot, index) {
        const active = index === activeIndex;
        dot.hidden = index >= pageCount;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });

      previousButton.disabled = activeIndex === 0;
      nextButton.disabled = activeIndex >= pageCount - 1 || slider.scrollLeft >= maxScroll - 2;
    }

    function requestControlsUpdate() {
      if (updateFrame) cancelAnimationFrame(updateFrame);
      updateFrame = requestAnimationFrame(function() {
        updateFrame = null;
        updateControls();
      });
    }

    function requestExtendedDesktopSettle() {
      if (!usesExtendedDesktop || mobileQuery.matches || !sliderIsEnabled()) return;
      window.clearTimeout(settleTimer);
      settleTimer = window.setTimeout(function() {
        const targetIndex = getActiveIndex();
        const targetLeft = Math.min(getMaxScroll(), targetIndex * getStep());
        if (Math.abs(slider.scrollLeft - targetLeft) <= 1) return;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        slider.scrollTo({ left: targetLeft, behavior: reducedMotion ? 'auto' : 'smooth' });
      }, 120);
    }

    function scrollToIndex(index) {
      const targetIndex = Math.min(pageCount - 1, Math.max(0, index));
      const targetLeft = Math.min(getMaxScroll(), targetIndex * getStep());
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      slider.scrollTo({ left: targetLeft, behavior: reducedMotion ? 'auto' : 'smooth' });
    }

    previousButton.addEventListener('click', function() {
      scrollToIndex(getActiveIndex() - 1);
    });

    nextButton.addEventListener('click', function() {
      scrollToIndex(getActiveIndex() + 1);
    });

    dots.forEach(function(dot, index) {
      dot.addEventListener('click', function() {
        scrollToIndex(index);
      });
    });

    slider.addEventListener('scroll', function() {
      requestControlsUpdate();
      requestExtendedDesktopSettle();
    }, { passive: true });
    window.addEventListener('resize', function() {
      requestControlsUpdate();
    });

    if (usesMobileDynamicHeight) {
      slides.forEach(function(slide) {
        slide.querySelectorAll('img').forEach(function(image) {
          image.addEventListener('load', requestControlsUpdate, { passive: true });
        });
        slide.querySelectorAll('video').forEach(function(video) {
          video.addEventListener('loadedmetadata', requestControlsUpdate, { passive: true });
        });
      });

      if ('ResizeObserver' in window) {
        const slideResizeObserver = new ResizeObserver(requestControlsUpdate);
        slides.forEach(function(slide) {
          slideResizeObserver.observe(slide);
        });
        slider._bsgFlexibleColumns2SlideResizeObserver = slideResizeObserver;
      }
    }

    slider.classList.add('is-initializing-slider');
    slider.scrollLeft = 0;
    requestAnimationFrame(function() {
      slider.scrollLeft = 0;
      slider.classList.remove('is-initializing-slider');
      updateControls();
    });
  }

  function initFlexibleColumns2(sectionRoot) {
    if (!sectionRoot || sectionRoot.dataset.bsgFlexibleColumns2Initialized === 'true') return;
    sectionRoot.dataset.bsgFlexibleColumns2Initialized = 'true';

    initRaisedTextOverlap(sectionRoot);
    initSectionSlider(sectionRoot);

    sectionRoot.querySelectorAll('[data-bsg-flexible-columns-2-anchor]').forEach(function(trigger) {
      trigger.addEventListener('click', function(event) {
        const anchorId = trigger.getAttribute('data-bsg-flexible-columns-2-anchor');
        if (scrollToAnchor(anchorId)) event.preventDefault();
      });
    });

    sectionRoot.querySelectorAll('[data-bsg-flexible-columns-2-raised-image-card]').forEach(function(card) {
      function openPrimaryButton() {
        const primaryButton = card.querySelector('[data-bsg-flexible-columns-2-primary-button]');
        if (primaryButton) primaryButton.click();
      }

      card.addEventListener('click', function(event) {
        if (event.target.closest('a, button, input, select, textarea, summary')) return;
        openPrimaryButton();
      });

      card.addEventListener('keydown', function(event) {
        if (event.target !== card || (event.key !== 'Enter' && event.key !== ' ')) return;
        event.preventDefault();
        openPrimaryButton();
      });
    });
  }

  function initFloatingNavigation(root) {
    if (!root || root.dataset.bsgFlexibleColumns2FloatingNavInitialized === 'true') return;

    const sourceSectionId = root.getAttribute('data-bsg-flexible-columns-2-source-section');
    const sourceSection = document.getElementById(sourceSectionId);
    if (!sourceSection) return;

    root.dataset.bsgFlexibleColumns2FloatingNavInitialized = 'true';

    let activePanel = 'main';
    let frame = null;
    let lastScrollY = window.scrollY;
    let mobileVisibleAtY = window.scrollY;
    let manuallyCollapsed = false;
    let userHasOpenedFlexibleDropdown = false;
    const collapseButton = root.querySelector('[data-bsg-flexible-columns-2-nav-collapse]');
    const exploreTrigger = root.querySelector('[data-bsg-flexible-columns-2-nav-open="explore"]');
    const collapseDropdownsRow = root.querySelector('[data-bsg-flexible-columns-2-collapse-dropdowns-row]');
    const collapseDropdownsButton = root.querySelector('[data-bsg-flexible-columns-2-collapse-dropdowns]');
    const headerMenu = document.getElementById('Details-menu-drawer-container');

    function isMobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function isDesktop() {
      return window.matchMedia('(min-width: 750px)').matches;
    }

    function desktopIsTight() {
      return window.matchMedia('(min-width: 750px) and (max-width: 1199px)').matches || root.dataset.bsgFlexibleColumns2FloatingNavContentTight === 'true';
    }

    function headerMenuOpen() {
      return document.body.classList.contains('overflow-hidden-mobile') || (headerMenu && (headerMenu.hasAttribute('open') || headerMenu.classList.contains('menu-opening')));
    }

    function setVisible(visible) {
      const wasVisible = root.classList.contains('bsg-flexible-columns-2-floating-nav--visible');
      root.classList.toggle('bsg-flexible-columns-2-floating-nav--visible', visible);
      root.setAttribute('aria-hidden', visible ? 'false' : 'true');
      document.body.classList.toggle('bsg-flexible-columns-2-floating-nav-visible', visible);
      if (visible && !wasVisible && isMobile()) mobileVisibleAtY = window.scrollY;
    }

    function updateVisibility() {
      const footer = document.querySelector('footer');
      const footerReached = footer && footer.getBoundingClientRect().top <= window.innerHeight;
      const openingSectionPassed = sourceSection.getBoundingClientRect().bottom <= getHeaderOffset();
      setVisible((isMobile() || isDesktop()) && openingSectionPassed && !headerMenuOpen() && !footerReached);
    }

    function setCollapsed(collapsed) {
      root.classList.toggle('bsg-flexible-columns-2-floating-nav--collapsed', collapsed);
      if (!collapseButton) return;
      collapseButton.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      collapseButton.setAttribute('aria-label', collapsed ? 'Expand page navigation' : 'Collapse page navigation');
    }

    function syncPanelHeight() {
      if (!isMobile()) return;
      const panel = root.querySelector('[data-bsg-flexible-columns-2-nav-panel="' + activePanel + '"]');
      if (!panel) return;
      const maxHeight = Math.min(window.innerHeight * 0.74, 600) - 32;
      root.style.setProperty('--bsg-flexible-columns-2-floating-nav-panel-height', Math.min(panel.scrollHeight, maxHeight) + 'px');
    }

    function getOpenFlexibleDropdowns() {
      return Array.from(document.querySelectorAll('[data-bsg-flexible-dropdown-item][open]'));
    }

    function syncCollapseDropdownsButton() {
      if (!collapseDropdownsRow) return;
      const hasOpenDropdowns = getOpenFlexibleDropdowns().length > 0;
      if (!hasOpenDropdowns) userHasOpenedFlexibleDropdown = false;
      collapseDropdownsRow.hidden = !isDesktop() || !userHasOpenedFlexibleDropdown || !hasOpenDropdowns;
    }

    function setPanel(panel, preserveCollapse) {
      if (!preserveCollapse) setCollapsed(false);
      activePanel = panel;
      root.setAttribute('data-bsg-flexible-columns-2-nav-active', panel);
      if (exploreTrigger) exploreTrigger.setAttribute('aria-expanded', panel === 'explore' ? 'true' : 'false');

      root.querySelectorAll('[data-bsg-flexible-columns-2-nav-panel]').forEach(function(element) {
        const panelName = element.getAttribute('data-bsg-flexible-columns-2-nav-panel');
        const isActive = panelName === panel;
        const keepDesktopMain = isDesktop() && panel === 'explore' && panelName === 'main';
        element.setAttribute('aria-hidden', (isActive || keepDesktopMain) ? 'false' : 'true');
        element.inert = !isActive && !keepDesktopMain;
      });

      window.requestAnimationFrame(syncPanelHeight);
    }

    function syncDesktopCompact() {
      const wasCompact = root.classList.contains('bsg-flexible-columns-2-floating-nav--compact');
      const compact = isDesktop() && desktopIsTight();
      root.classList.toggle('bsg-flexible-columns-2-floating-nav--compact', compact);

      if (compact) {
        setCollapsed(true);
      } else if (wasCompact && !manuallyCollapsed) {
        setCollapsed(false);
      }
    }

    function syncDesktopPosition() {
      if (!isDesktop()) return;

      let widestRect = null;
      let widestWidth = 0;
      let sibling = sourceSection.nextElementSibling;

      while (sibling) {
        if (sibling.matches('footer, .shopify-section-group-footer-group') || sibling.querySelector('footer')) break;

        const candidates = [];
        if (sibling.matches('.page-width')) candidates.push(sibling);
        sibling.querySelectorAll('.page-width').forEach(function(candidate) {
          candidates.push(candidate);
        });

        candidates.forEach(function(candidate) {
          const rect = candidate.getBoundingClientRect();
          if (rect.width > widestWidth && rect.width > 0) {
            widestWidth = rect.width;
            widestRect = rect;
          }
        });

        sibling = sibling.nextElementSibling;
      }

      if (!widestRect) {
        const fallback = sourceSection.querySelector('.page-width');
        if (fallback) widestRect = fallback.getBoundingClientRect();
      }

      if (!widestRect) return;
      const availableGutter = Math.max(0, window.innerWidth - widestRect.right);
      const navigationWidth = root.offsetWidth || 185;
      const desiredGap = 16;
      const unavoidableOverlap = Math.max(0, navigationWidth + desiredGap - availableGutter);
      const rightOffset = Math.max(12, Math.round(availableGutter - navigationWidth - desiredGap));

      root.dataset.bsgFlexibleColumns2FloatingNavContentTight = unavoidableOverlap > navigationWidth * 0.35 ? 'true' : 'false';
      root.style.setProperty('--bsg-flexible-columns-2-floating-nav-right', rightOffset + 'px');
    }

    function requestUpdate() {
      if (frame) return;
      frame = window.requestAnimationFrame(function() {
        frame = null;
        updateVisibility();
      });
    }

    root.querySelectorAll('[data-bsg-flexible-columns-2-nav-open]').forEach(function(button) {
      button.addEventListener('click', function() {
        const panel = button.getAttribute('data-bsg-flexible-columns-2-nav-open');
        manuallyCollapsed = false;
        if (isDesktop() && activePanel === panel) {
          setPanel('main');
          return;
        }
        setPanel(panel);
      });
    });

    root.querySelectorAll('[data-bsg-flexible-columns-2-nav-back]').forEach(function(button) {
      button.addEventListener('click', function() {
        manuallyCollapsed = false;
        setPanel('main');
      });
    });

    root.querySelectorAll('[data-bsg-flexible-columns-2-anchor]').forEach(function(trigger) {
      trigger.addEventListener('click', function(event) {
        const anchorId = trigger.getAttribute('data-bsg-flexible-columns-2-anchor');
        if (!scrollToAnchor(anchorId)) return;
        event.preventDefault();
        manuallyCollapsed = false;
        setPanel('main');
        if (isMobile()) setCollapsed(true);
      });
    });

    root.querySelectorAll('[data-bsg-flexible-columns-2-return-top]').forEach(function(button) {
      button.addEventListener('click', function() {
        manuallyCollapsed = false;
        setPanel('main');
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });

    root.querySelectorAll('[data-bsg-flexible-columns-2-contact-form]').forEach(function(button) {
      button.addEventListener('click', function() {
        manuallyCollapsed = false;
        setPanel('main');
        openContactFormDrawer(button);
      });
    });

    if (collapseDropdownsButton) {
      collapseDropdownsButton.addEventListener('click', function() {
        getOpenFlexibleDropdowns().forEach(function(dropdown) {
          dropdown.open = false;
        });
        userHasOpenedFlexibleDropdown = false;
        syncCollapseDropdownsButton();
      });
    }

    document.addEventListener('click', function(event) {
      const summary = event.target.closest && event.target.closest('[data-bsg-flexible-dropdown-item] > summary');
      if (!summary) return;
      const dropdown = summary.parentElement;
      if (dropdown && !dropdown.open) userHasOpenedFlexibleDropdown = true;
    }, true);

    document.addEventListener('toggle', function(event) {
      if (!event.target.matches || !event.target.matches('[data-bsg-flexible-dropdown-item]')) return;
      syncCollapseDropdownsButton();
    }, true);

    if (collapseButton) {
      collapseButton.addEventListener('click', function() {
        const isCollapsed = root.classList.contains('bsg-flexible-columns-2-floating-nav--collapsed');
        manuallyCollapsed = !isCollapsed;
        setPanel('main', !isCollapsed);
        if (!isCollapsed) setCollapsed(true);
      });
    }

    window.addEventListener('scroll', function() {
      const nextScrollY = window.scrollY;
      const delta = nextScrollY - lastScrollY;

      if (isMobile() && root.classList.contains('bsg-flexible-columns-2-floating-nav--visible') && activePanel === 'main') {
        if (delta > 14 && nextScrollY - mobileVisibleAtY >= 120) setCollapsed(true);
        if (delta < -14 && !manuallyCollapsed) setCollapsed(false);
      }

      lastScrollY = nextScrollY;
      requestUpdate();
    }, { passive: true });

    window.addEventListener('resize', function() {
      requestUpdate();
      syncPanelHeight();
      syncDesktopPosition();
      syncDesktopCompact();
      syncCollapseDropdownsButton();
    });

    if (headerMenu) {
      headerMenu.addEventListener('toggle', requestUpdate);
    }

    document.addEventListener('shopify:section:load', function() {
      requestUpdate();
      syncDesktopPosition();
    });

    setPanel('main');
    syncDesktopPosition();
    syncDesktopCompact();
    syncCollapseDropdownsButton();
    requestUpdate();
  }

  function initHeaderNavigation(root) {
    if (!root || root.dataset.bsgFlexibleColumns2HeaderNavInitialized === 'true') return;
    root.dataset.bsgFlexibleColumns2HeaderNavInitialized = 'true';

    const exploreButtons = Array.from(root.querySelectorAll('[data-bsg-flexible-columns-2-header-nav-explore]'));
    const exploreMenus = Array.from(root.querySelectorAll('[data-bsg-flexible-columns-2-header-nav-menu]'));
    const collapseDropdownsButton = root.querySelector('[data-bsg-flexible-columns-2-collapse-dropdowns]');
    const headerMenu = document.getElementById('Details-menu-drawer-container');
    const primaryHeader = document.querySelector('.section-header');
    const sourceSection = document.getElementById(root.getAttribute('data-bsg-flexible-columns-2-source-section'));
    const mobileBottomNavigation = root.classList.contains('bsg-flexible-columns-2-header-nav--mobile-bottom');
    const mobileBottom = root.querySelector('.bsg-flexible-columns-2-header-nav__mobile-bottom');
    const mobilePanels = Array.from(root.querySelectorAll('[data-bsg-flexible-columns-2-mobile-panel]'));
    let userHasOpenedFlexibleDropdown = false;
    let hasActivated = false;
    let visibilityFrame = null;

    function getOpenFlexibleDropdowns() {
      return Array.from(document.querySelectorAll('[data-bsg-flexible-dropdown-item][open]'));
    }

    function syncCollapseDropdownsButton() {
      if (!collapseDropdownsButton) return;
      const hasOpenDropdowns = getOpenFlexibleDropdowns().length > 0;
      if (!hasOpenDropdowns) userHasOpenedFlexibleDropdown = false;
      collapseDropdownsButton.hidden = !userHasOpenedFlexibleDropdown || !hasOpenDropdowns;
    }

    function syncMobilePanelHeight() {
      if (!mobileBottom) return;
      const activePanel = mobileBottom.querySelector('[data-bsg-flexible-columns-2-mobile-panel="' + mobileBottom.getAttribute('data-bsg-flexible-columns-2-mobile-active') + '"]');
      if (activePanel) mobileBottom.style.setProperty('--bsg-flexible-columns-2-mobile-panel-height', activePanel.offsetHeight + 'px');
    }

    function setMobilePanel(panelName) {
      if (!mobileBottom) return;
      mobileBottom.setAttribute('data-bsg-flexible-columns-2-mobile-active', panelName);
      mobilePanels.forEach(function(panel) {
        const isActive = panel.getAttribute('data-bsg-flexible-columns-2-mobile-panel') === panelName;
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        panel.inert = !isActive;
      });
      const mobileExploreButton = mobileBottom.querySelector('[data-bsg-flexible-columns-2-header-nav-explore]');
      if (mobileExploreButton) mobileExploreButton.setAttribute('aria-expanded', panelName === 'explore' ? 'true' : 'false');
      window.requestAnimationFrame(syncMobilePanelHeight);
    }

    function closeExploreMenu() {
      exploreButtons.forEach(function(button) {
        button.setAttribute('aria-expanded', 'false');
      });
      exploreMenus.forEach(function(menu) {
        menu.hidden = true;
      });
      if (mobileBottom && mobileBottom.getAttribute('data-bsg-flexible-columns-2-mobile-active') !== 'main') setMobilePanel('main');
    }

    function toggleExploreMenu(button) {
      const menu = document.getElementById(button.getAttribute('aria-controls'));
      if (!menu) return;
      if (menu.hasAttribute('data-bsg-flexible-columns-2-mobile-panel')) {
        setMobilePanel('explore');
        return;
      }
      const willOpen = button.getAttribute('aria-expanded') !== 'true';
      closeExploreMenu();
      button.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      menu.hidden = !willOpen;
    }

    function headerMenuOpen() {
      return document.body.classList.contains('overflow-hidden-mobile') || (headerMenu && (headerMenu.hasAttribute('open') || headerMenu.classList.contains('menu-opening')));
    }

    function syncVisibility() {
      visibilityFrame = null;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const atPageTop = scrollTop <= 2;
      if (!atPageTop) hasActivated = true;
      if (atPageTop) hasActivated = false;

      const mobileBottomMode = mobileBottomNavigation && window.matchMedia('(max-width: 749px)').matches;
      const sourceHasPassed = sourceSection && sourceSection.getBoundingClientRect().bottom <= 0;
      const secondaryOwnsHeader = !mobileBottomMode && hasActivated && !atPageTop;
      const visible = (mobileBottomMode ? sourceHasPassed : secondaryOwnsHeader) && !headerMenuOpen();
      if (primaryHeader) primaryHeader.classList.toggle('bsg-flexible-columns-2-main-header-suppressed', secondaryOwnsHeader);
      root.style.setProperty('--bsg-flexible-columns-2-header-nav-top', '0px');
      root.classList.toggle('is-visible', visible);
      root.setAttribute('aria-hidden', visible ? 'false' : 'true');
      document.body.classList.toggle('bsg-flexible-columns-2-mobile-bottom-nav-visible', Boolean(mobileBottomMode && visible));
      if (!visible) closeExploreMenu();
    }

    function requestVisibilitySync() {
      if (visibilityFrame) return;
      visibilityFrame = window.requestAnimationFrame(syncVisibility);
    }

    exploreButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        toggleExploreMenu(button);
      });
    });

    root.querySelectorAll('[data-bsg-flexible-columns-2-mobile-back]').forEach(function(button) {
      button.addEventListener('click', function() {
        setMobilePanel('main');
        const exploreButton = mobileBottom && mobileBottom.querySelector('[data-bsg-flexible-columns-2-header-nav-explore]');
        if (exploreButton) exploreButton.focus();
      });
    });

    root.querySelectorAll('[data-bsg-flexible-columns-2-anchor]').forEach(function(trigger) {
      trigger.addEventListener('click', function(event) {
        const anchorId = trigger.getAttribute('data-bsg-flexible-columns-2-anchor');
        if (!scrollToAnchor(anchorId)) return;
        event.preventDefault();
        closeExploreMenu();
      });
    });

    root.querySelectorAll('[data-bsg-flexible-columns-2-return-top]').forEach(function(button) {
      button.addEventListener('click', function() {
        closeExploreMenu();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });

    root.querySelectorAll('[data-bsg-flexible-columns-2-contact-form]').forEach(function(button) {
      button.addEventListener('click', function() {
        closeExploreMenu();
        openContactFormDrawer(button);
      });
    });

    if (collapseDropdownsButton) {
      collapseDropdownsButton.addEventListener('click', function() {
        getOpenFlexibleDropdowns().forEach(function(dropdown) {
          dropdown.open = false;
        });
        userHasOpenedFlexibleDropdown = false;
        syncCollapseDropdownsButton();
      });
    }

    document.addEventListener('click', function(event) {
      const summary = event.target.closest && event.target.closest('[data-bsg-flexible-dropdown-item] > summary');
      if (summary) {
        const dropdown = summary.parentElement;
        if (dropdown && !dropdown.open) userHasOpenedFlexibleDropdown = true;
      }

      if (!root.contains(event.target)) closeExploreMenu();
    }, true);

    document.addEventListener('toggle', function(event) {
      if (!event.target.matches || !event.target.matches('[data-bsg-flexible-dropdown-item]')) return;
      syncCollapseDropdownsButton();
    }, true);

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') closeExploreMenu();
    });

    window.addEventListener('scroll', requestVisibilitySync, { passive: true });
    window.addEventListener('resize', function() {
      requestVisibilitySync();
      syncMobilePanelHeight();
    });
    if (headerMenu) headerMenu.addEventListener('toggle', requestVisibilitySync);
    if (primaryHeader && 'MutationObserver' in window) {
      const headerObserver = new MutationObserver(requestVisibilitySync);
      headerObserver.observe(primaryHeader, { attributes: true, attributeFilter: ['class'] });
      root._bsgFlexibleColumns2HeaderObserver = headerObserver;
    }

    syncCollapseDropdownsButton();
    setMobilePanel('main');
    syncVisibility();
  }

  function initAllFlexibleColumns2(root) {
    const scope = root || document;

    if (scope.matches && scope.matches('[data-bsg-flexible-columns-2-header-nav]')) {
      initHeaderNavigation(scope);
    }

    scope.querySelectorAll('[data-bsg-flexible-columns-2-header-nav]').forEach(function(headerNavigation) {
      initHeaderNavigation(headerNavigation);
    });

    if (scope.matches && scope.matches('[data-bsg-flexible-columns-2-floating-nav]')) {
      initFloatingNavigation(scope);
    }

    scope.querySelectorAll('[data-bsg-flexible-columns-2-floating-nav]').forEach(function(floatingNavigation) {
      initFloatingNavigation(floatingNavigation);
    });

    if (scope.matches && scope.matches('.shopify-section') && scope.querySelector('[data-bsg-flexible-columns-2]')) {
      initFlexibleColumns2(scope);
    }

    scope.querySelectorAll('.shopify-section').forEach(function(sectionRoot) {
      if (sectionRoot.querySelector('[data-bsg-flexible-columns-2]')) {
        initFlexibleColumns2(sectionRoot);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAllFlexibleColumns2(document);
    });
  } else {
    initAllFlexibleColumns2(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initAllFlexibleColumns2(event.target);
  });

  window.addEventListener('resize', function() {
    document.querySelectorAll('[data-bsg-flexible-columns-2]').forEach(function(sectionRoot) {
      initRaisedTextOverlap(sectionRoot);
    });
  });
})();
